import gql from "graphql-tag";

export const mallDetailsFragment = gql`
  fragment MallDetailsFragment on Mall {
    id
    name
    code
    description
    longitude
    latitude
    contactPerson
    mobileNo
    telephoneNo
    email
    totalLandArea
    mallAdmin {
      id
      firstName
      lastName
      email
    }
    status
    mallOpening
    mallClosing
    expressDeliveryAvailable
    isServiceable
    isNationwideDelivery
    isInMallPickup
    isServiceable
    serviceArea
    genMerchCutoffTime
    groceryCutoffTime
    sameDayGmCutoffTime
    foodAndBevCutoffTime
    smMarketExternalId
    smMarketExternalName
    smMarketExternalCode
    expressLongDistanceAvailable
    nextDayAvailable
    sameDayAvailable
    sameDayGmCutoffTime
    city
    provinceCode
    provinceName
  }
`;

export const mallShippingMethodFragment = gql`
  fragment MallShippingMethodFragment on MallShippingMethod {
    id
    startTime
    endTime
    shippingMethod {
      id
      name
      deliveryType
    }
  }
`;
